import { combineReducers } from '@reduxjs/toolkit';

import { authReducer } from '@/features/auth/model/auth.slice';
import { uiReducer } from '@/features/ui/model/ui.slice';

/**
 * Combinador raíz de todos los slices.
 * Cada feature exporta su reducer y se agrega aquí.
 */
export const rootReducer = combineReducers({
  auth: authReducer,
  ui: uiReducer,
});
